import { FLOW, STATUS, flowIndex, type SubmissionStatus } from '@commpass/shared';
import { CheckIcon } from './Icons';

const STEPS: { key: SubmissionStatus; label: string }[] = FLOW.map((k) => ({
  key: k,
  label: STATUS[k].label,
}));

/** The big horizontal pipeline shown on the submission detail page. */
export function Pipeline({ status }: { status: string }) {
  const cur = flowIndex(status as SubmissionStatus);
  return (
    <div className="pipe">
      {STEPS.map((step, i) => {
        const done = i < cur;
        const isCur = i === cur;
        return (
          <div key={step.key} className={`pipe-step${done ? ' done' : ''}${isCur ? ' cur' : ''}`}>
            {i > 0 && <div className="pipe-line" />}
            <div className="pipe-node">
              {done ? <CheckIcon /> : isCur ? <span className="pulse" /> : null}
            </div>
            <div style={{ fontSize: 11.5, marginTop: 6, color: 'var(--muted)' }}>{step.label}</div>
          </div>
        );
      })}
    </div>
  );
}
